import { useEffect, useRef, useState } from "react";
import {
  Anchor,
  AppShell,
  Avatar,
  Badge,
  Box,
  Burger,
  Button,
  Card,
  Divider,
  Flex,
  Group,
  Image,
  Indicator,
  Menu,
  Radio,
  ScrollArea,
  Switch,
  Text,
  TextInput,
  Title,
  Tooltip,
  UnstyledButton,
  rem,
} from "@mantine/core";
import "@mantine/core/styles.css";
import {
  useDebouncedState,
  useDisclosure,
  useDocumentTitle,
  useMediaQuery,
  useNetwork,
  useOs,
} from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { Spotlight, SpotlightActionData, spotlight } from "@mantine/spotlight";
import "@mantine/spotlight/styles.css";
import {
  IconBell,
  IconCheck,
  IconCode,
  IconDownload,
  IconPin,
  IconPinnedOff,
  IconSearch,
  IconSignRight,
  IconSwitch,
  IconTrash,
  IconUser,
  IconX,
} from "@tabler/icons-react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { _sideNavData } from "../../../_setup/navdata/_sideNavData";
import { MessageResponse } from "../../../model/MessageResponse";
import {
  TblDmEmployeeModel,
  TblUserProfile,
} from "../../../model/TblDmEmployeeModel";
import {
  repositoryLog,
  repositoryMaster,
  repositoryPos,
} from "../../_const/_constVar";
import classes from "../../_style/NavbarSegmented.module.css";
import { NotificationExtension } from "../../extension/NotificationExtension";
import { isNullOrEmpty } from "../../extension/StringExtension";
import {
  isMenuPathAllowed,
  searchSideNavData,
} from "../../helper/FunctionHelper";
import { AuthProvider } from "../../helper/IAuthProvider";
import { LinksGroupProps } from "../../model/_base/LinksGroupProps";
import { TransferBranch } from "../_transferBranch/_transferBranch";
import _breadcrumb from "./_breadcrumb";
import { SkeletonBase } from "./_skeleton";
import { LinksGroup } from "./NavbarLinksGroup";
import style from "./style.module.css";
import { _socket, SocketExtension } from "../../socket/socket";
import { AvatarUtils } from "../../../common/ColorByName/AvatarUtils";
import { useMutation, useQuery } from "@tanstack/react-query";
import { HistoryNotification } from "../../../model/HistoryNotification";
import { formatDateTransfer } from "../../../common/FormatDate/FormatDate";

import { Tabs } from "@sinm/react-chrome-tabs";
import "@sinm/react-chrome-tabs/css/chrome-tabs.css";
import "@sinm/react-chrome-tabs/css/chrome-tabs-dark-theme.css";
import routes from "../../../_setup/router/routes";
import HomeView from "../../../views/home/HomeView";
import { red } from "../../../const/variables";
import Countdown from "react-countdown";
import { DateBuild, HashCommit, Version } from "../../../config";
import { record, Replayer } from "rrweb";

const _logo =
  "https://hanoicomputercdn.com/media/lib/30-05-2024/favicon-hacom-2024.png";
let _id = 1;
function uniqId() {
  return _id++;
}

function createNewTab(pathname: string, content: any, title: string) {
  const id = uniqId();
  return {
    id: "tab " + pathname + "-" + id,
    title: title,
    favicon: _logo,
    active: true,
    content: content,
  };
}
//context
interface EventMessage {
  id: string;
  time: number;
  expires: number;
  event: string;
  topic: string;
  title: string;
  message: string;
}
interface DataFake {
  id: string;
  data: any;
}
export const Layout1 = () => {
  // #region state

  const location = useLocation();
  const navigate = useNavigate();
  const [loadingSkeleton, setLoadingSkeleton] = useState(true);
  const [mobileOpened, { toggle: toggleMobile, close: closeMobile }] =
    useDisclosure();
  const [
    desktopOpened,
    { open: openDeskstop, toggle: toggleDesktop, close: closeDesktop },
  ] = useDisclosure(true);
  const [sideNavs, setSideNavs] = useState<LinksGroupProps[]>([]);
  const [menuOpened, setMenuOpened] = useState(false);
  const [isExpanded, setIsExpanded] = useState(true);
  const [checkedPinMenu, setCheckedPinMenu] = useState(
    localStorage.getItem("checkedPinMenu") === "true",
  );
  const [checked, setChecked] = useState(
    localStorage.getItem("checkedPinSearch") === "true",
  );
  const [environment, setEnvironment] = useState<string | undefined>("");
  useEffect(() => {
    const env = window.location.hostname.includes("pos.hacom.vn")
      ? "production"
      : "development";
    setEnvironment(env);
  }, []);

  const [isOrderNotificationEnabled, setIsOrderNotificationEnabled] = useState(
    () => {
      const savedState = localStorage.getItem("isOrderNotificationEnabled");
      return savedState ? JSON.parse(savedState) : true;
    },
  );

  //#endregion
  useEffect(() => {
    const pathsCheck = [
      "/sell/",
      "/delivery-config/",
      "/config-system/",
      "/category-data/",
      "/warehouse-config/",
      "/authozire/",
      "/organization/",
      "/request-transfer/",
      "/warranty/",
      "/invoice",
      "/bill/",
      "/reduced-approval/",
      "/customer-management/",
      "/testing/testing-technique",
      "/department",
      "/report",
      "/Statement",
    ];

    const closeMenus = pathsCheck?.some((path) =>
      location.pathname.includes(path),
    );

    if (closeMenus && !checkedPinMenu) {
      closeDesktop();
      closeMobile();
    }
    // const queryParams = new URLSearchParams(location.search);
    // const jwt = queryParams.get("token");
    // console.log("check auth !");
    const token = AuthProvider.isAuthenticated();
    console.log(token);
    //  if (!token && !jwt) {
    if (!token) {
      navigate("/auth/login");
      // const _sso = BASE_SSO + "/" + "?callback=" + window.location.origin + "/";
      // console.log(_sso);
      // window.location.href = _sso;
    }

    // const storedDate = localStorage.getItem("dateExpires");
    // if (storedDate) {
    //   const expiryDate = new Date(storedDate); // Chuyển đổi chuỗi thành Date
    //   const currentTime = new Date();
    //   const timeDifference = expiryDate.getTime() - currentTime.getTime();

    //   if (timeDifference > 0) {
    //     const minutesLeft = Math.floor(timeDifference / 60000); // phut
    //     if (minutesLeft > 500) {
    //       const token = AuthProvider.signout();
    //       if (token) {
    //         console.log("logout",timeDifference,minutesLeft);
    //         navigate("/auth/login");
    //       }
    //     }
    //   }
    // }

    const _title = _sideNavData.find((item) =>
      item.links?.find((link) => link.link === location.pathname),
    )?.label;
    setTitle(_title ?? "Hacom");

    setLoadingSkeleton(false);
    window.scrollTo(0, 0);
    return () => {
      setLoadingSkeleton(true);
    };
  }, [location.pathname]);
  const [title, setTitle] = useState("");
  useDocumentTitle(title);
  const userName = localStorage.getItem("userName") || "";
  const empId = localStorage.getItem("empId") ?? "";

  // matine
  const [notifications, setNotifications] = useState<HistoryNotification[]>([]);
  const [countNoti, setCountNotifications] = useState<number>(0);

  const renderLogo = () => (
    <Image radius="md" h={60} w="auto" fit="contain" src={_logo} />
  );
  //randomColor
  const getColorByName = (name: string) => {
    if (typeof name !== "string" || name.length === 0) {
      return "black";
    }
    const colors = [
      "#70173c",
      "#004c3f",
      "#503372",
      "#17406c",
      "#354147",
      "#aeb3bd",
      "#ffb4c2",
    ];
    const index = name.charCodeAt(0) % colors.length;
    return "#17406c";
  };

  // Lấy ký tự đầu tiên và cuối cùng
  const firstLetter = userName.charAt(0).toUpperCase();
  // const lastLetter = userName.charAt(userName.length - 1).toUpperCase();

  const firstLetterColor = getColorByName(userName);
  // const lastLetterColor = getColorByName(userName);
  // search menu
  function searchDataSide(q: string) {
    if (isNullOrEmpty(q)) return setSideNavs(_sideNavData);
    return setSideNavs(searchSideNavData(sideNavs, q));
  }

  const actions: SpotlightActionData[] = sideNavs.flatMap(
    (group, groupIndex) =>
      group.links
        ? group.links.map((link, linkIndex) => ({
            id: `action-${groupIndex}-${linkIndex}`,
            label: link.label,
            description: group.label,
            onClick: async () => {
              if (!link.link.includes("authozire/user-page")) {
                var resCheck = await repositoryMaster.get<
                  MessageResponse<Array<string>>
                >("/api/v1/menugroup/check");
                if (resCheck && resCheck?.data && resCheck.success) {
                  if (resCheck.data && resCheck.data.length > 0) {
                    if (isMenuPathAllowed(link.link, resCheck.data))
                      navigate(link.link);
                    else navigate("/");
                  } else navigate("/");
                } else navigate("/");
              } else navigate(link.link);
            },
          }))
        : [],
  );

  // const links = sideNavs.map((item) => (
  //   <LinksGroup {...item} key={item.label} />
  // ));

  const links = sideNavs
    .map((item) => ({
      ...item, // Giữ nguyên các thuộc tính của item
      links: item.links?.filter((link) => !link.hidden), // Lọc các link con có hidden là true
    }))
    .map((item) => (
      <LinksGroup
        {...item}
        key={item.label}
        isCollapsed={!desktopOpened}
        isPinned={checkedPinMenu}
        open={toggleDesktop}
      />
    ));
  const os = useOs();
  const [locationVC, setLocation] = useState("");

  //#endregion
  function success(position: { coords: { latitude: any; longitude: any } }) {
    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;
    setLocation("latitude: " + latitude + "-" + " longitude: " + longitude);
  }

  function error1() {
    console.log("Unable to retrieve your location");
  }
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(success, error1);
    } else {
      console.log("Geolocation not supported");
    }
  }, []);
  const handleLogout = async (noti: boolean = false) => {
    const userNameBG = localStorage.getItem("userName") || "";
    const clientId = localStorage.getItem("clientId") || "NULL";
    const empIdBG = localStorage.getItem("empId") ?? "";

    const repository = repositoryMaster;
    let urlCreate = `/api/v1/Auth/logout`;
    let callapi = await repository.post<MessageResponse<boolean>>(urlCreate, {
      username: userNameBG,
      os: os,
      clientId: clientId,
      location: locationVC,
    });
    if (callapi && callapi.success) {
      await AuthProvider.signout();
      if (AuthProvider.isAuthenticated()) {
        if (noti) NotificationExtension.Fails("Đăng xuất thất bại !");
        return;
      }
      if (noti) {
        NotificationExtension.Success("Đăng xuất thành công");
        setIsConnected(false);
        SocketExtension.Disconnect();
      }
      navigate("/auth/login");
    } else NotificationExtension.Fails("Đăng xuất thất bại !");
  };
  // const [user, setUser] = useState<TblDmEmployeeModel | null>(null);
  const [userHeader, setUserHeader] = useState<TblUserProfile | null>(null);
  useEffect(() => {
    const token = localStorage.getItem("token");
    const getUserLocal = localStorage.getItem("userLoginHeader");
    if (getUserLocal) setUserHeader(JSON.parse(getUserLocal) as TblUserProfile);
    if (token && token.length > 10 && getUserLocal) {
      getUser();
      getNoti();
    }
  }, []);
  const [key, setKey] = useDebouncedState("", 300);
  const [readMess, setReadMess] = useDebouncedState("null", 300);
  const getNoti = async (skip?: number) => {
    try {
      // Tạo base URL
      let url = "/api/v1/Logging/list";
      const params = [];
      if (key.trim()) params.push(`key=${encodeURIComponent(key.trim())}`);
      if (readMess !== "null")
        params.push(`active=${encodeURIComponent(Number(readMess))}`);
      if (skip) params.push(`&skip=${skip}`);
      if (params.length > 0) {
        url += "?" + params.join("&");
      }

      const resCheck =
        await repositoryLog.get<MessageResponse<Array<HistoryNotification>>>(
          url,
        );

      if (resCheck && resCheck.success && resCheck.httpStatusCode === 200) {
        if (skip) setNotifications((x) => [...x, ...resCheck.data]);
        else setNotifications(resCheck.data);
        setCountNotifications(resCheck.totalCount);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
      return;
    }
  };

  const handleExpandClick = () => {
    getNoti(notifications.length);
  };

  const activeNoti = async (id: number) => {
    await repositoryLog.post<MessageResponse<Array<HistoryNotification>>>(
      "/api/v1/Logging/reads",
      [id],
      true,
    );
  };

  const getMenu = async () => {
    var resCheck = await repositoryMaster.get<MessageResponse<Array<string>>>(
      "/api/v1/menugroup/check",
    );
    if (resCheck && resCheck?.data && resCheck.success) {
      const dataMenu = ["/key-access/sso-get-access-key", ...resCheck?.data];

      if (dataMenu && dataMenu.length > 0) {
        const _checkRouter = _sideNavData
          .map((item) => {
            const filteredLinks = item?.links?.filter((linkObj) =>
              isMenuPathAllowed(linkObj.link, dataMenu),
            );

            return {
              ...item,
              links: filteredLinks,
            };
          })
          .filter((item) => (item?.links?.length ?? 0) > 0);
        // loc menu show ra
        setSideNavs(_checkRouter);
        if (!isMenuPathAllowed(location.pathname, dataMenu)) navigate("/");
      } else {
        navigate("/");
        setSideNavs([]);
      }
    }
  };

  const getUser = async () => {
    // var res = await repositoryPos.get<MessageResponse<TblDmEmployeeModel>>(
    //   "/api/v1/TblDmEmployee/detail-seft"
    // );
    // if (res && res?.data && res.success) {
    //   setUser(res.data);
    // } else {
    //   await handleLogout();
    // }

    //
    if (
      userName === "hopnk1" ||
      userName === "vinhnv" ||
      userName === "quan-1509" ||
      userName === "a-00222" ||
      userName === "ManhNV"
    )
      setSideNavs(_sideNavData);
    else {
      getMenu();
    }
  };

  // const getDataUserByHeader = async () => {
  //   const res = await repositoryMaster.post<MessageResponse<TblUserProfile>>(
  //     "/api/v1/Auth/getProfile",
  //     []
  //   );

  //   if (res && res?.success) {
  //     setUserHeader(res?.data);
  //     localStorage.setItem("userLoginHeader", JSON.stringify(res?.data));
  //   }
  // };

  // useQuery({
  //   queryKey: ["dataUser"],
  //   queryFn: getDataUserByHeader,
  //   refetchInterval: 1000 * 60 * 5,
  // });

  // useEffect(() => {
  //   if (userName === "hopnk11" || userName === "vinhnv1") {
  //   } else getMenu();
  // }, [location.pathname]);

  const [isConnected, setIsConnected] = useState(false);
  useEffect(() => {
    function onConnect(e: any) {
      setIsConnected(true);
    }
    function onDisconnect() {
      setIsConnected(false);
    }
    if (!isConnected) SocketExtension.On("connect", onConnect);
    if (isConnected) {
      SocketExtension.OnSeft(async (a: any) => {
        if (a.logout && a.logout === true) {
          //   await handleLogout();
        } else {
          if (a.message && a.message.length > 0 && isOrderNotificationEnabled) {
            NotificationExtension.PushBrowser(a.message);
          }
          await getNoti();
        }
      });
      SocketExtension.On("disconnect", onDisconnect);
      // navigator.serviceWorker.ready.then((registrationReady) => {
      //   if (registrationReady && registrationReady.active)
      //     if (AuthProvider.isAuthenticated()) {
      //       const _empId = localStorage.getItem("empId") ?? "";
      //       if (userName && _empId) {
      //         const postData = {
      //           userName: userName,
      //           empId: _empId,
      //           type: "listen",
      //           typeHandler: "login",
      //         };
      //         registrationReady.active?.postMessage(postData);
      //       }
      //     }
      // });
    }
    // console.log(isConnected);
    // SocketExtension.OnSeft((a: any) => {
    //   if (a.message) {
    //     //  NotificationExtension.Info(a.message);
    //     NotificationExtension.PushBrowser(a.message);
    //   }
    // });
    // SocketExtension.On("disconnect", onDisconnect);
    // console.log(isConnected);

    return () => {
      if (!isConnected) SocketExtension.Off("connect", onConnect);
      if (isConnected) SocketExtension.Off("disconnect", onDisconnect);
    };
    //   } else SocketExtension.Disconnect();
    // }, []);
  }, [isConnected]);

  const [token, setToken] = useState<string | null>(null);

  useEffect(() => {
    // Lấy token từ localStorage
    const savedToken = localStorage.getItem("token");
    setToken(savedToken); // Cập nhật state
  }, []);

  const openModalTransferBranch = () =>
    modals.openConfirmModal({
      title: <Title order={5}>Chuyển chi nhánh</Title>,
      children: <TransferBranch />,
      labels: { confirm: "Confirm", cancel: "Cancel" },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => console.log("Confirmed"),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });

  const openModal = () =>
    modals.openConfirmModal({
      title: <Title order={4}>Token của bạn</Title>,
      size: "400px",
      children: (
        <Text mt={15} style={{ maxWidth: "100%", wordWrap: "break-word" }}>
          {token}
        </Text>
      ),
      labels: { confirm: "Confirm", cancel: "Cancel" },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => console.log("Confirmed"),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });

  const infoUser = () => {
    return (
      <UnstyledButton>
        <Indicator
          inline
          processing={networkStatus.online}
          size={16}
          offset={5}
          position="bottom-end"
          color={networkStatus.online ? "green" : "red"}
          withBorder
        >
          <AvatarUtils value={userName} show={false} />
        </Indicator>
      </UnstyledButton>
    );
  };

  const closeMenuAndOpenModal = async () => {
    // setMenuOpened(false);
    // openModalTransferBranch();
    const response = await repositoryPos.get<MessageResponse<any>>(
      `/api/v1/TblDmEmployee/detail-employees`,
    );

    if (response && response.success) {
      let result = response.data;
      localStorage.setItem("userLogin", JSON.stringify(result));
      localStorage.setItem("empId", result.id);
      await getUser();
      await repositoryPos.get<MessageResponse<any>>(
        `/api/v1/TblDmEmployee/remove-cache`,
      );
      NotificationExtension.Success("Cập nhật thành công !");
    }
  };
  const { isPending, error, data } = useQuery({
    queryKey: ["repoData"],
    queryFn: () => {
      const clientId = localStorage.getItem("clientId") || "";
      if (clientId)
        try {
          repositoryMaster.get(
            "/api/v1/auth/update-user-online?clientId=" + clientId,
          );
        } catch {
          return;
        }
    },
    refetchInterval: 1000 * 60 * 10,
  });

  //
  const [tabs, setTabs] = useState([
    {
      id: "/",
      favicon: _logo,
      title: "Trang chủ",
      active: true,
      // routes:"/",
      content: <HomeView />,
    },
  ]);

  const [darkMode, setDarkMode] = useState(false);

  // const addTab = () => {
  //   setTabs([...tabs, createNewTab()]);
  // };
  const addTab = () => {
    // const newTab = createNewTab("");
    // setTabs([...tabs.map((tab) => ({ ...tab, active: false })), newTab]);
    // navigate(newTab.id); // Điều hướng đến tab mới
  };
  const active = (id: string) => {
    setTabs(
      tabs.map((tab) => ({
        ...tab,
        active: id === tab.id,
      })),
    );
  };

  const close = (id: string) => {
    setTabs(tabs.filter((tab) => tab.id !== id));
  };

  const reorder = (tabId: string, fromIndex: any, toIndex: number) => {
    const beforeTab = tabs.find((tab) => tab.id === tabId);
    if (!beforeTab) {
      return;
    }
    let newTabs = tabs.filter((tab) => tab.id !== tabId);
    newTabs.splice(toIndex, 0, beforeTab);
    setTabs(newTabs);
  };

  const findLabelByLink = (linkToFind: string) => {
    // Duyệt qua từng nhóm trong _sideNavData
    for (const group of _sideNavData) {
      // Kiểm tra từng link trong links
      const foundLink = group?.links?.find((link) => link.link === linkToFind);
      if (foundLink) {
        return foundLink.label; // Trả về label nếu tìm thấy
      }
    }
    return null; // Trả về null nếu không tìm thấy
  };
  useEffect(() => {
    // Kiểm tra nếu tab đã tồn tại cho route hiện tại, nếu không thì tạo tab mới
    const tabExists = tabs?.filter((tab) => tab.id === location.pathname);
    //   if (tabExists < 0) {

    if (tabExists.length < 5 && location.pathname.length > 1) {
      // Đường dẫn không khớp route nào (VD thêm dấu / cuối hoặc route chưa khai báo) thì không tạo tab, tránh sập cả layout
      const _out = (
        routes.state.matches.find((x) => x.pathname === location.pathname)
          ?.route as any
      )?.element;
      if (!_out) return;
      const label = findLabelByLink(location.pathname);
      setTabs((prevTabs) => [
        ...prevTabs.map((tab) => ({ ...tab, active: false })),
        createNewTab(location.pathname, _out, label ?? ""),
      ]);
    }

    //  }
    // else {
    //   setTabs((prevTabs) =>
    //     prevTabs.map((tab) => ({
    //       ...tab,
    //       active: tab.id === location.pathname,
    //     }))
    //   );
    // }
  }, [location]);
  // useEffect(() => {
  //   console.log(tabs);
  // }, [tabs]);
  const [checkedTabs, setCheckedTabs] = useState(
    localStorage.getItem("checkedTabs") === "true",
  );

  useEffect(() => {
    localStorage.setItem("checkedTabs", checkedTabs?.toString() ?? "false");
    localStorage.setItem(
      "checkedPinMenu",
      checkedPinMenu?.toString() ?? "false",
    );

    setTabs((prevTabs) => prevTabs.filter((tab) => tab.id !== ""));

    if (checkedPinMenu) {
      openDeskstop();
    }
  }, [checkedTabs, checkedPinMenu]);

  const networkStatus = useNetwork();
  const handleBottomReached = () => {
    console.log("Đã cuộn đến cuối nội dung!");
    // Thực hiện hành động khi cuộn đến cuối
  };
  const Completionist = () => <></>;
  const renderer = (data: any) => {
    if (data?.completed) {
      // Render trạng thái khi đếm ngược hoàn tất
      return <Completionist />;
    } else {
      // Hiển thị đếm ngược với số ngày, giờ, phút, giây
      return (
        <>
          <Group justify="center" mt={"lg"}>
            <Badge color="blue">
              {" "}
              {data.days}ngày {data.hours} giờ:{data.minutes}phút:{data.seconds}
              giây
            </Badge>

            <Image
              // width={30}
              height={100}
              src={
                "https://www.pngplay.com/wp-content/uploads/6/Coming-Soon-Vector-PNG-Clipart-Background.png"
              }
              w="auto"
              fit="contain"
            />
          </Group>
        </>
      );
    }
  };

  const [timeLeft, setTimeLeft] = useState<string>(""); // Lưu trữ thời gian còn lại

  useEffect(() => {
    // Hàm tính toán thời gian còn lại
    const calculateTimeLeft = () => {
      const storedDate = localStorage.getItem("dateExpires");
      if (storedDate) {
        const expiryDate = new Date(storedDate); // Chuyển đổi chuỗi thành Date
        const currentTime = new Date();
        const timeDifference = expiryDate.getTime() - currentTime.getTime();

        if (timeDifference > 0) {
          const minutesLeft = Math.floor(timeDifference / 60000); // Chuyển từ ms sang phút
          setTimeLeft(` SESSION: ${minutesLeft} phút`);
        } else {
          setTimeLeft("Hết hạn");
        }
      }
    };

    // Tính toán ngay khi component được render lần đầu
    calculateTimeLeft();

    // Đặt interval để tính lại mỗi phút
    const intervalId = setInterval(calculateTimeLeft, 60000); // 60000ms = 1 phút

    // Cleanup: Xóa interval khi component unmount
    return () => {
      clearInterval(intervalId);
    };
  }, []);
  const isSmallScreen = useMediaQuery("(max-width: 1200px)");
  const isSmallScreen2 = useMediaQuery("(max-width: 850px)");
  const isSmallScreen3 = useMediaQuery("(max-width: 500px)");
  const [versionFe, setVersionFe] = useState<boolean>(false);
  const getVersion = useQuery({
    queryKey: ["getVersion"],
    queryFn: async () => {
      try {
        const res = await repositoryMaster.get<string>(
          "/api/v1/home/check-version-fe",
        );
        if (
          res &&
          res !== "" &&
          res.toString().trim() !== Version?.toString().trim() &&
          process.env.NODE_ENV === "production"
        )
          setVersionFe(true);
        else setVersionFe(false);
      } catch (error) {
        console.log(error);
      }
    },
    refetchInterval: 1000 * 60 * 5,
    //   refetchInterval: 1000,
  });
  //record

  // ✅ Hàm gửi API
  // const sendEventsToAPI = async (events: any[]) => {
  //   console.log("🔄 Gửi sự kiện lên API:", events?.length);
  //   await repositoryLog.post(
  //     "/api/v1/Logging/add-video",
  //     {
  //       video: JSON.stringify({ events }),
  //     },
  //     true
  //   );
  // };

  // const useScreenRecorder = (intervalMs = 900000) => {
  //   const recordedEvents = useRef<any[]>([]);

  //   const mutation = useMutation({
  //     mutationFn: sendEventsToAPI,
  //     onSuccess: () => console.log("✅ Gửi dữ liệu thành công"),
  //     onError: (error) => console.error("❌ Lỗi gửi dữ liệu:", error),
  //   });

  //   useEffect(() => {
  //     // 🔴 Bắt đầu ghi màn hình
  //     const stopRecording = record({
  //       emit(event) {
  //         recordedEvents.current.push(event);
  //       },
  //     });

  //     // ⏳ Tự động gửi API mỗi 60 giây
  //     const interval = setInterval(() => {
  //       if (recordedEvents.current.length > 0) {
  //         mutation.mutate(recordedEvents.current); // Gửi API
  //         recordedEvents.current = []; // Xóa sự kiện đã gửi
  //       }
  //     }, intervalMs);

  //     return () => {
  //       if (stopRecording) {
  //         stopRecording();
  //       }
  //       clearInterval(interval);
  //     };
  //   }, []);

  //   return null; // Không cần return gì cả
  // };
  // useScreenRecorder();

  // console.log("Loggnotifications", notifications);
  return (
    <>
      <AppShell
        header={{ height: environment === "production" ? 50 : 70 }}
        navbar={{
          width: !desktopOpened && !checkedPinMenu ? 80 : 300,
          breakpoint: "md",
          collapsed: { mobile: !desktopOpened },
        }}
        styles={{
          navbar: {
            transition: "width 0.3s ease-out ease-in",
            display: "flex",
            overflow: "hidden",
          },
        }}
        padding="md"
      >
        <AppShell.Header>
          {environment === "development" && (
            <Flex direction="column">
              {/* Hàng thông báo phiên bản thử nghiệm */}
              <Flex justify="center" align="center" bg="#FFD700">
                <Text size="md" fw="bold" color="red" lineClamp={1}>
                  Đây là phiên bản thử nghiệm. Vui lòng truy cập{" "}
                  <Anchor
                    href="https://pos.hacom.vn"
                    target="_blank"
                    color="blue"
                  >
                    link này
                  </Anchor>{" "}
                  để vào bản chính thức.
                </Text>
              </Flex>

              {/* Nội dung khác trong Flex */}
              {/* // viết tiếp vào đây */}
            </Flex>
          )}

          <Flex
            gap="md"
            justify="space-between"
            align="center"
            direction="row"
            wrap="wrap"
            ml={"22px"}
            mr={"30px"}
          >
            <Group mt="-4">
              <Burger
                opened={desktopOpened && !checkedPinMenu}
                onClick={() => {
                  if (!checkedPinMenu) toggleDesktop();
                }}
                size="sm"
              />
              <Link to="/">{renderLogo()}</Link>
            </Group>

            {/* <Group>
              {" "}
              <Countdown
                renderer={renderer}
                date={new Date("2025-01-01T00:00:00")}
              />{" "}
            </Group> */}

            {!isSmallScreen2 && !versionFe && (
              <Group>
                {/* <Tooltip
                label={`${userHeader?.code} - ${userHeader?.fullname} - ${userHeader?.brachName} - ${timeLeft}`}
                withArrow
              > */}
                {!isSmallScreen && (
                  <Text
                    style={{
                      textTransform: "uppercase",
                      fontSize: "12px",
                      cursor: "pointer",
                      overflow: "hidden",
                      position: "absolute",
                      left: "50%",
                      transform: "translateX(-50%)",
                    }}
                    fw={500}
                    lineClamp={1}
                  >
                    {`${userHeader?.code} - ${userHeader?.fullname} - ${
                      userHeader?.brachName
                    }
                     - 
                     ${new Date().toLocaleTimeString([], {
                       hour: "2-digit",
                       minute: "2-digit",
                     })}
                      - ${new Date().toLocaleDateString("en-GB")}`}{" "}
                    - {timeLeft}
                  </Text>
                )}
                {isSmallScreen && (
                  <Text
                    style={{
                      textTransform: "uppercase",
                      fontSize: "12px",
                      cursor: "pointer",
                      overflow: "hidden",
                      position: "absolute",
                      left: "50%",
                      transform: "translateX(-50%)",
                    }}
                    fw={500}
                    lineClamp={1}
                  >
                    {`${userHeader?.code} - ${userHeader?.fullname} - ${userHeader?.brachName}`}{" "}
                  </Text>
                )}
                {/* </Tooltip> */}
              </Group>
            )}

            {versionFe && process.env.NODE_ENV === "production" && (
              <>
                <Text
                  size="lg"
                  fw={900}
                  variant="gradient"
                  gradient={{ from: "blue", to: "cyan", deg: 90 }}
                >
                  Đã có phiên bản mới, xin vui lòng nhấn F5 hoặc tải lại
                  trang...
                </Text>
              </>
            )}

            {/* <Group>
            <_breadcrumb></_breadcrumb>
            </Group> */}
            {/* <Group>
              <Text>{dateTime}</Text>
            </Group> */}

            {/* <Countdown
              renderer={renderer}
              date={new Date("2025-01-01T00:00:00")}
            /> */}
            <Group justify="flex-start">
              <Menu position="bottom-start">
                <Flex pt={0} pb={2} gap={15} className={style.search}>
                  {!isSmallScreen3 && (
                    <>
                      {/* <Button
                        leftSection={<IconTrash size={18} />}
                        variant="filled"
                        size="xs"
                        color="red"
                        radius={"lg"}
                      >
                        Xóa data cache
                      </Button> */}
                      <Tooltip
                        transitionProps={{ transition: "pop", duration: 300 }}
                        refProp="rootRef"
                        label={checked ? "Bỏ lưu tìm kiếm" : "Lưu tìm kiếm"}
                      >
                        <Switch
                          size="lg"
                          checked={checked}
                          onChange={(event) => {
                            const checked = event.currentTarget.checked;
                            if (checked) {
                              localStorage.setItem("checkedPinSearch", "true");
                              setChecked(true);
                            } else {
                              localStorage.setItem("checkedPinSearch", "false");
                              setChecked(false);
                            }
                          }}
                          color="blue"
                          thumbIcon={
                            checked ? (
                              <IconCheck
                                size={12}
                                color="var(--mantine-color-teal-6)"
                                stroke={3}
                              />
                            ) : (
                              <IconX
                                size={12}
                                color="var(--mantine-color-red-6)"
                                stroke={3}
                              />
                            )
                          }
                        />
                      </Tooltip>
                      <Tooltip
                        transitionProps={{ transition: "pop", duration: 300 }}
                        refProp="rootRef"
                        label={checkedPinMenu ? "Bỏ ghim menu" : "Ghim menu"}
                      >
                        <Switch
                          size="lg"
                          checked={checkedPinMenu}
                          style={{ cursor: "pointer" }}
                          color={"green"}
                          thumbIcon={
                            checkedPinMenu ? (
                              <IconPin
                                style={{
                                  width: rem(12),
                                  height: rem(12),
                                  color: "teal",
                                }}
                                stroke={3}
                              />
                            ) : (
                              <IconPinnedOff
                                style={{
                                  width: rem(12),
                                  height: rem(12),
                                  color: red.light,
                                }}
                                stroke={3}
                              />
                            )
                          }
                          onChange={(event) => {
                            setCheckedPinMenu(event.currentTarget.checked);
                          }}
                        />
                      </Tooltip>
                    </>
                  )}
                  {/* <Tooltip
                    transitionProps={{ transition: "pop", duration: 300 }}
                    refProp="rootRef"
                    label={"Dạng Tab"}
                  >
                    <Switch
                      size="lg"
                      checked={checkedTabs}
                      style={{ cursor: "pointer" }}
                      onLabel="Bật"
                      offLabel="Tắt"
                      onChange={(event) =>
                        setCheckedTabs(event.currentTarget.checked)
                      }
                    />
                  </Tooltip> */}
                  {/* <Button
                    variant="default"
                    fullWidth
                    radius="xl"
                    justify="space-between"
                    onClick={spotlight.open}
                    leftSection={
                      <Flex align="center" gap={10}>
                        <IconSearch size={20} />
                        <Text fw={500} size="sm">
                          Tìm kiếm
                        </Text>
                      </Flex>
                    }
                    rightSection={
                      <Flex
                        bg="#f8f9fa"
                        p={6}
                        mr={-6}
                        align={"center"}
                        justify="center"
                        style={{
                          borderRadius: "100px",
                          border: "0.5px solid #ccc",
                        }}
                      >
                        <Text
                          style={{ whiteSpace: "nowrap" }}
                          fw={500}
                          size="xs"
                        >
                          Ctrl + K
                        </Text>
                      </Flex>
                    }
                  ></Button> */}
                  <Divider m="5px 0" orientation="vertical" />
                  <Menu.Target>
                    <Indicator
                      withBorder
                      position="bottom-end"
                      processing
                      disabled={
                        notifications.filter((x) => !x.read === true).length < 1
                      }
                      label={countNoti > 999 ? "999+" : countNoti}
                      onClick={async () => {
                        await getNoti();
                      }}
                      onDoubleClick={() => {
                        setIsOrderNotificationEnabled((prev: any) => {
                          const newState = !prev;
                          localStorage.setItem(
                            "isOrderNotificationEnabled",
                            JSON.stringify(newState),
                          ); // Lưu trạng thái vào localStorage
                          NotificationExtension.Info(
                            newState
                              ? "Tính năng hiển thị thông báo đã bật!"
                              : "Tính năng hiển thị thông báo đã tắt!",
                          );
                          return newState;
                        });
                      }}
                      size={16}
                      offset={5}
                    >
                      <Tooltip label="Click double để bật tắt thông báo">
                        <Avatar
                          style={{ cursor: "pointer" }}
                          color={isOrderNotificationEnabled ? "blue" : "gray"}
                          radius="xl"
                        >
                          <IconBell size="1.5rem" />
                        </Avatar>
                      </Tooltip>
                    </Indicator>
                  </Menu.Target>
                  <Menu.Dropdown w={555} bd={"2px solid #ccc"}>
                    <Menu.Label>
                      <Text fw="bold" size="md">
                        Thông báo
                      </Text>
                      <Flex mt={"xs"} justify={"space-between"}>
                        <TextInput
                          onChange={(e) => {
                            setKey(e.target.value);
                          }}
                          placeholder="Nhập từ khoá..."
                        ></TextInput>

                        <Radio.Group
                          name="favoriteFramework"
                          label=""
                          description=""
                          withAsterisk
                          onChange={(e) => {
                            setReadMess(e);
                          }}
                        >
                          <Group mt="xs">
                            <Radio value="null" label="Tất cả" />
                            <Radio value="1" label="Chưa đọc" />
                          </Group>
                        </Radio.Group>
                        <Button
                          ml={"xs"}
                          leftSection={<IconSearch size={14} />}
                          onClick={async () => await getNoti()}
                        >
                          Tìm kiếm
                        </Button>
                      </Flex>
                    </Menu.Label>
                    {/* dom ảo scroll */}
                    <ScrollArea
                      pb={10}
                      h={
                        notifications.length >= 4 && !isExpanded
                          ? "520"
                          : "79vh"
                      }
                      style={{
                        transition: "300ms ease-in-out",
                      }}
                      //  onBottomReached={handleBottomReached}
                      scrollbars={!isExpanded ? false : "y"}
                      offsetScrollbars
                    >
                      {notifications.map((notification) => (
                        <Menu.Item
                          key={notification.id}
                          onClick={async () => {
                            if (notification.message) {
                              const list = notification.message.split(" ");
                              const isOrder =
                                notification.message.startsWith("Đơn hàng");
                              if (list && list.length > 0) {
                                if (isOrder) {
                                  const orderNumber = list.find((x) =>
                                    x.startsWith("DH"),
                                  );
                                  if (orderNumber) {
                                    const url = `/api/v1/CreateSellItem/details?orderNumber=${orderNumber}`;
                                    const response =
                                      await repositoryPos.get<
                                        MessageResponse<any>
                                      >(url);

                                    if (response && response.success) {
                                      navigate("/sell/view-order", {
                                        state: {
                                          id: response.data.orderHeader.id,
                                          orderNumber:
                                            response.data.orderHeader
                                              .orderNumber,
                                          orderType:
                                            response.data.orderHeader.orderTypeId.toString(),
                                          actionType: "view",
                                        },
                                      });
                                    }
                                  }
                                }
                              }
                            }

                            //active
                            if (
                              notifications.filter((x) => !x.read === true)
                                .length > 0
                            ) {
                              await activeNoti(notification.id);
                            }
                            await getNoti();
                          }}
                        >
                          <Flex align="center" gap={10}>
                            <Indicator
                              withBorder
                              position="bottom-end"
                              processing
                              disabled={notification.read}
                              size={15}
                              offset={5}
                            >
                              <AvatarUtils
                                value={
                                  notification.createdBy
                                    ?.toString()
                                    .split("-")[0] ?? ""
                                }
                                show={false}
                              />
                            </Indicator>

                            <Flex direction="column">
                              <Text size="md" fw={500} lineClamp={0}>
                                {notification.message}{" "}
                              </Text>
                              <Flex
                                gap={10}
                                align="center"
                                justify="space-between"
                                mt={5}
                              >
                                <Text size="sm">
                                  {formatDateTransfer(notification.createdAt)}
                                </Text>
                                <Text fw="bold" size="sm" c="red">
                                  {notification.createdBy}
                                </Text>
                              </Flex>
                            </Flex>

                            {notification.message?.startsWith("File:") &&
                              notification.link && (
                                <Anchor
                                  href={notification.link}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  title="Tải file"
                                >
                                  <Tooltip label="Tải file" withArrow>
                                    <IconDownload
                                      size={24}
                                      style={{ cursor: "pointer" }}
                                    />
                                  </Tooltip>
                                </Anchor>
                              )}
                          </Flex>
                        </Menu.Item>
                      ))}
                    </ScrollArea>
                    {/* {!isExpanded && notifications.length >= 4 && (
                      <Button
                        fullWidth
                        variant="transparent"
                        onClick={handleExpandClick}
                      >
                        Xem thêm
                      </Button>
                    )} */}
                    <Button
                      fullWidth
                      variant="transparent"
                      onClick={handleExpandClick}
                    >
                      Xem thêm
                    </Button>
                  </Menu.Dropdown>
                  <>
                    <Menu
                      width={300}
                      shadow="md"
                      opened={menuOpened}
                      onChange={setMenuOpened}
                    >
                      <Menu.Target>
                        <Tooltip
                          transitionProps={{
                            transition: "pop",
                            duration: 300,
                          }}
                          label={userName}
                        >
                          {infoUser()}
                        </Tooltip>
                      </Menu.Target>
                      <Menu.Dropdown p={0}>
                        <Card
                          withBorder
                          p={0}
                          pb={10}
                          radius="md"
                          className={classes.card}
                          style={{
                            backgroundColor: `${firstLetterColor}od`,
                          }}
                        >
                          <Card.Section
                            h={100}
                            style={{
                              backgroundColor: `${firstLetterColor}`,
                              filter: "opacity(0.4)",
                            }}
                          />

                          <Avatar
                            className={classes.avatar}
                            style={{ cursor: "pointer" }}
                            radius="xl"
                            bg={firstLetterColor}
                            w={60}
                            h={60}
                            mx="auto"
                            mt={-30}
                          >
                            <Text size="xl" fw={700} c="#fff">
                              {firstLetter}
                            </Text>
                          </Avatar>
                          <Text ta="center" size="xl" fw={600} mt="sm">
                            {userName}
                          </Text>
                          <Text ta="center" fw={500} mt="sm">
                            {userHeader?.departmentName}
                          </Text>
                          <Text ta="center" fw={500}>
                            {userHeader?.fullname}
                          </Text>

                          <Text ta="center" fz="sm" c="dimmed">
                            {userHeader?.roleName}
                          </Text>
                          {/* <Text ta="center" fz="sm" c="dimmed">
                            {networkStatus.effectiveType}
                          </Text> */}
                          {/* <Group mt="md" justify="center" gap={30}>
                      {items}
                    </Group> */}
                          <Divider mt={20} my="sm" />
                          <Flex pl={10} pr={10} pb={10} direction="column">
                            <Button
                              leftSection={<IconUser size={18} />}
                              variant="filled"
                              size="sm"
                              // color="blue"
                              color={firstLetterColor}
                              // style={{
                              //   backgroundColor: `${firstLetterColor}`,
                              //   filter: "opacity(0.8)",
                              // }}
                              onClick={() => {
                                navigate("/authozire/user-page");
                              }}
                            >
                              Trang cá nhân
                            </Button>
                            <Button
                              leftSection={<IconSwitch size={18} />}
                              variant="light"
                              size="sm"
                              mt={10}
                              color={firstLetterColor}
                              onClick={closeMenuAndOpenModal}
                            >
                              Cập nhật dữ liệu
                            </Button>
                            <Button
                              leftSection={<IconCode size={18} />}
                              size="sm"
                              mt={10}
                              variant="light"
                              color={firstLetterColor}
                              onClick={openModal}
                            >
                              Hiển Thị Token
                            </Button>
                            {/* <Button
                              leftSection={<IconCode size={18} />}
                              size="sm"
                              mt={10}
                              variant="light"
                              color={firstLetterColor}
                              onClick={openModal}
                            >
                              Thông tin phần mềm
                            </Button> */}
                            <Button
                              leftSection={<IconSignRight size={18} />}
                              size="sm"
                              mt={10}
                              variant="light"
                              color={firstLetterColor}
                              onClick={async () => {
                                await handleLogout(true);
                              }}
                            >
                              Đăng xuất
                            </Button>
                          </Flex>
                        </Card>
                      </Menu.Dropdown>
                    </Menu>
                  </>
                </Flex>
              </Menu>
            </Group>
          </Flex>
        </AppShell.Header>
        <AppShell.Navbar py="xs">
          <AppShell.Section>
            <Spotlight
              actions={actions}
              limit={5}
              nothingFound="Nothing found..."
              highlightQuery
              searchProps={{
                leftSection: (
                  <IconSearch
                    style={{ width: "20px", height: "20px" }}
                    stroke={1.5}
                  />
                ),
                placeholder: "Search...",
              }}
            />
          </AppShell.Section>
          <AppShell.Section grow component={ScrollArea} h={"90%"}>
            <ScrollArea className={classes.links}>
              <div className={classes.linksInner}>{links}</div>
              <Divider my="sm" />
            </ScrollArea>
          </AppShell.Section>
          <AppShell.Section grow>
            <Group justify="center">
              <Title textWrap="balance" order={6}>
                Version
              </Title>
            </Group>
            <Group justify="center">
              <Text fw={500} c="blue">
                {DateBuild}
              </Text>
              <Divider size="sm" orientation="vertical" />
              <Text fw={500} c={"blue"}>
                {Version}
              </Text>
              <Divider size="sm" orientation="vertical" />
              <Text fw={500} c={"blue"}>
                {HashCommit}
              </Text>
            </Group>{" "}
          </AppShell.Section>
          {/* <AppShell.Section>
            <a
              className={classes.link}
              style={{ cursor: "pointer" }}
              onClick={async () => {
                await handleLogout(true);
              }}
            >
              <IconLogout className={classes.linkIcon} stroke={1.5} />
              <span>Đăng xuất</span>
            </a>
          </AppShell.Section> */}
        </AppShell.Navbar>
        <AppShell.Main>
          {loadingSkeleton ? (
            <SkeletonBase visible={loadingSkeleton}></SkeletonBase>
          ) : (
            <>
              {/* <Button
                onClick={() => {
                  // var res = SocketExtension.SendMessageToUserName<any>(
                  //   "BACKGROUP",
                  //   {
                  //     message: "test noti",

                  //     //  type: TypePushSocket.NotSelf,
                  //   }
                  // );
                  const user = "chien123";
                  var res = SocketExtension.SendMessageToEmp<any>(2284, {
                    message:
                      "Bắn message to nhân viên có mã 2284 !" + user,

                    //  type: TypePushSocket.NotSelf,
                  });
                  console.log(res);
                }}
              >
                Click push
              </Button> */}
              {checkedTabs ? (
                <div>
                  <Tabs
                    darkMode={darkMode}
                    onTabClose={close}
                    onTabReorder={reorder}
                    onTabActive={active}
                    tabs={tabs}
                  />

                  <div>
                    {tabs.map((tab, index) => (
                      <div
                        className="tabs-show-element"
                        key={index}
                        id={index.toString() + tab.id}
                        style={{ display: tab.active ? "block" : "none" }}
                      >
                        {tab.content}
                      </div>
                    ))}
                  </div>

                  {/* <button onClick={addTab}>Add Tab</button>
                <button onClick={closeAll}>Close All</button>
                <button onClick={toogleDarkMode}>Toogle Dark Mode</button> */}
                </div>
              ) : (
                <Outlet />
              )}
            </>
          )}
        </AppShell.Main>
      </AppShell>
    </>
  );
};
